import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { AdvanceRocket } from "../../../components/AdvanceRocket";
import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import {
  Screen1krp,
  Course,
  After,
  Workout,
  Advantage,
  Levels,
  Stages,
  Program,
  Results,
  Reviews,
  Learn,
  Cost,
  Author,
  SmiExperts,
  VideoReviews,
  Free
} from "../../../components/LandingTemplates/krp";

const TITLE = 'Курс развития памяти и внимания';
const DESCRIPTION = 'Как и любая мышца в нашем организме, мозг нуждается в регулярной тренировке.Уже на первом занятии мы поделимся с вами приёмами эффективного запоминания, сохранения и воспроизведения информации.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1krp/>
      <Course/>
      <After/>
      <Workout/>
      <Advantage/>
      <Levels/>
      <Stages/>
      <Program/>
      <Results/>
      <Reviews/>
      <Learn/>
      <Cost
        widgetFull={<GetCourseWidget hash={'2dfa943ff011d1fc74f8e97bb504fa2ecd8e3420'} id={'300218'}/>}
      />
      <AdvanceRocket bgColor={'#faf7ff'}/>
      <Author/>
      <SmiExperts/>
      <VideoReviews/>
      <Free widgetFree={<GetCourseWidget hash={'fde0aaa15e89c71bfd85b39817cd0901f5094549'} id={'300135'}/>}/>
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
